class ConsumersHeadingController  {
    constructor() {}
}

class ConsumersHeading{
    constructor(){
        this.require= {
            container: '^consumersContainer'
        };
        this.bindings= {
            query: '<',
        };
        this.controller = ConsumersHeadingController;
    }

    templateUrl($element, $attrs) {
        return $attrs.templateUrl || 'consumers-heading.html'
    }
}

angular.module('emun.consumer').component('consumersHeading', new ConsumersHeading());

export { ConsumersHeadingController, ConsumersHeading }